import React from 'react';
import '../App.css';
import { useAppSelector } from '../app/hooks';

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

import { Site } from '../utils/types';

//	--------------------------------------------------------------------------
//
//	R E D U X   S T A T E   M A N A G E M E N T
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	F U N C T I O N S
//
//	--------------------------------------------------------------------------

import { siteName, fn_updateIcon } from '../utils/functions';

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export default function SiteIcon(props: { site?: Site; size: number; colour?: string }) {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  //	------------------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	------------------------------------------------------------

  return (
    <div
      className="fc"
      style={{
        flex: '0 0 ' + props.size.toString() + 'px',
        width: props.size.toString() + 'px',
        height: props.size.toString() + 'px',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {(props.site?.icon ?? undefined) !== undefined &&
      (props.site?.icon ?? '') !== '' ? (
        <img
          style={{
            userSelect: 'none',
            border: 'none',
            borderRadius: '4px',
          }}
          src={fn_updateIcon({
            original: props.site?.icon ?? '',
            width: 80,
            height: 80,
            strokeWidth: 1.5,
            colour: props.colour ?? '#000000',
          })}
          /*src={props.site?.icon ?? undefined}*/
          alt={siteName({ site: props.site }).substring(0, 1).toUpperCase()}
          width={props.size.toString()}
          height={props.size.toString()}
        />
      ) : (
        <div
          className="fc text-colour border-colour background-colour"
          data-invert="T"
          style={{
            width: props.size.toString() + 'px',
            flex: '0 0 ' + props.size.toString() + 'px',
            fontSize: Math.round(props.size * 0.4).toString() + 'pt',
            justifyContent: 'center',
            alignItems: 'center',
            userSelect: 'none',
            borderRadius: '4px',
          }}
        >
          {siteName({ site: props.site }).substring(0, 1).toUpperCase()}
        </div>
      )}
    </div>
  );
  //
} // SiteIcon
